import React from "react";

/**
 * Pricing Section Component
 * Price and package charge fields
 */
const PricingSection = ({
  formData,
  setFormData,
  errors,
  disabled,
  currencySymbol,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="mb-6 grid grid-cols-1 md:grid-cols-2 gap-4">
      
      {/* Price Field */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Price *
        </label>

        <div
          className={`flex items-center border rounded-lg transition-colors ${
            errors.price
              ? "border-red-500"
              : "border-gray-300 focus-within:border-blue-500"
          } ${
            disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"
          } focus-within:ring-2 focus-within:ring-blue-500`}
        >
          <span className="px-3 text-gray-600 font-medium bg-gray-50 border-r">
            {currencySymbol}
          </span>

          <input
            type="text"
            inputMode="decimal"
            className="w-full px-4 py-3 outline-none bg-transparent"
            value={formData.price}
            onChange={handleChange}
            name="price"
            disabled={disabled}
            placeholder="0.00"
          />
        </div>

        {errors.price && (
          <p className="mt-1 text-sm text-red-600">{errors.price}</p>
        )}
      </div>

      {/* Package Charge Field */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Package Charge{" "}
          <span className="text-gray-500 text-xs">(optional)</span>
        </label>

        <div
          className={`flex items-center border rounded-lg transition-colors border-gray-300 ${
            disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"
          } focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500`}
        >
          <span className="px-3 text-gray-600 font-medium bg-gray-50 border-r">
            {currencySymbol}
          </span>

          <input
            type="text"
            inputMode="decimal"
            className="w-full px-4 py-3 outline-none bg-transparent"
            value={formData.packageCharge}
            onChange={handleChange}
            name="packageCharge"
            disabled={disabled}
            placeholder="0.00"
          />
        </div>
      </div>
    </div>
  );
};

export default PricingSection;